import {useState} from "react";

export const useInput = (initialValue, additionalOnChange) => {
    const [value, setValue] = useState(initialValue);

    return {
        value,
        setValue,
        reset: () => setValue(""),
        bind: {
            value,
            onChange: event => {
                setValue(event.target.value);
                if (additionalOnChange) {
                    additionalOnChange(event.target.value);
                }
            }
        }
    };
};